import { render, staticRenderFns } from "./EditUserLimitConsumption.vue?vue&type=template&id=35288a80&scoped=true&"
import script from "./EditUserLimitConsumption.vue?vue&type=script&lang=js&"
export * from "./EditUserLimitConsumption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35288a80",
  null
  
)

export default component.exports